import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { BackButton } from '@/components/BackButton/BackButton';
import { LogoSvg } from '@/components/Icons/LogoSvg';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/text';
import { paths } from '@/constants';
import { useToken } from '@/hooks';

export const RegistrationSuccess = () => {
    const { t } = useTranslation();
    const token = useToken();
    const navigate = useNavigate();

    return (
        <Box p="0 15px" textAlign="center" position="relative">
            <BackButton />
            <div className="inline-block mb-[50px]">
                <LogoSvg />
            </div>
            <Text variant="h3" color="text-primary" children={t('thank-registering')} className="mt-[20px]" />

            {token ? (
                <div className="mt-[40px]">
                    <Button
                        onClick={() => {
                            navigate(paths.start.index);
                        }}
                        variant="contained"
                        size="large"
                        className="w-[320px]"
                    >
                        {t('buttons.entering')}
                    </Button>
                </div>
            ) : (
                <Text variant="body1" color="text-text-primary" children={t('resend-email')} className="mt-[35px]" />
            )}
        </Box>
    );
};
